import TextPage from './TextPage';
import gql from 'graphql-tag';
import { compose, graphql } from 'react-apollo';

const query = gql`
    query staticDocument($tag: String!) {
        staticDocument(tag: $tag) {
            html
        }
    }
`;

interface IInputProps {
    children?: any;
}   

interface IResponse {
    data: any;
}

const getQueryForTag = (tag: string) => {
    return compose(graphql<IInputProps, IResponse>(query, { options: { variables: { tag } } }))(TextPage);
};

export const ContactEshop = getQueryForTag('contactEshop');
export const About = getQueryForTag('about');
export const Cooperation = getQueryForTag('cooperation');
export const TermsConditions = getQueryForTag('conditions');
export const Delivery = getQueryForTag('delivery');
export const PersonalData = getQueryForTag('personalData');
export const Loyalty = getQueryForTag('loyalty');
export const ReturnPolicy = getQueryForTag('returnPolicy');
export const Claim = getQueryForTag('claim');
export const Tracking = getQueryForTag('tracking');

export const Basket = getQueryForTag('basket');
export const Contacts = getQueryForTag('contacts');
export const BeforePurchase = getQueryForTag('beforePurchase');
export const AfterPurchase = getQueryForTag('afterPurchase');



// WEBPACK FOOTER //
// ./src/pages/TextPage/index.tsx